import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { createMarkup, getResponsiveType } from '../../utils';
import { Typography } from '../Typography';

interface PropertyListingBannerProps {
  banner: string;
}

// Styles
// THIS IS GROSS - we'll look either make new banners or better yet have banner data structured
// Future use issue

const StyledPropertyListingBanner = styled.li`
  ${({ theme: { media, space, borders, shadows, global } }) => css`
    .promo[style] {
      background-size: cover;
      border-radius: ${global.borderRadius.default};
      overflow: hidden;
      position: relative;
      min-height: auto !important;
      height: 100%; // cls fix

      .promo__body {
        z-index: 9;
        position: relative;
        color: #fff;
        padding: ${space.lg};
        width: 100%;
        height: 100%;

        > * {
          max-width: 612px;
        }
      }

      h2,
      h3 {
        ${getResponsiveType('titleMedium')}
        margin-bottom: ${space.md};
      }

      a {
        display: block;
        margin-top: ${space.lg};
        text-decoration: none;

        &:after {
          content: '';
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }

        &:before {
          content: '';
          display: block;
          width: 100%;
          max-width: 544px;
          height: 1px;
          opacity: 0.32;
          background-image: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
          border-radius: 2px;
          margin-bottom: ${space.md};
        }
      }

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-image: linear-gradient(270deg, rgba(17, 17, 17, 0) 0%, #111111 100%);
      }

      &:hover {
        box-shadow: ${shadows.small};
      }
    }

    // Table < styles

    @media (media-width: ${media.md}) {
    }
  `};
`;

// JSX

export const PropertyListingBanner: FC<PropertyListingBannerProps> = ({ banner, ...rest }) => (
  <StyledPropertyListingBanner {...rest}>{createMarkup(banner)}</StyledPropertyListingBanner>
);
